import gql from 'graphql-tag';

// Tenant isolation: intentionally uses org_some (single org) without parentOrg_some.
// The library view should only show the current org's ad groups — not child org data.
// For cross-org visibility (parent + children), use GET_ADGROUP_CREATIVES_LAUNCHER instead.
// See commit ce64ea218 (Apr 2023) for the deliberate split.
const GET_ADGROUP_CREATIVES = gql`
  query adgroupmedias($orgId: ID!) {
    adGroupCreativeses(where: { AND: { org_some: { id: $orgId } } }) {
      id
      adProviderId
      name
      isAmplifyDefault
      updatedAt
      medias(where: { flag: true }) {
        id
        name
        size
        fileType
        height
        width
        key
        url
        type
        org {
          id
          name
        }
        sharedWith {
          name
        }
        mediaNotes
        mediaHasNotes
      }
      flag
      org {
        id
        name
      }
    }
  }
`;

export default GET_ADGROUP_CREATIVES;
